/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import CrmLeadCommunicationRecievedBody from "components/CRMComponents/CRMLeadInformationComponents/CRMLeadCommunicationComponents/CrmLeadCommunicationBody/Recieved/CrmLeadCommunicationRecievedBody";

const CrmLeadCommunicationRecieved = () => {
  useEffect(() => {
    document.title = "CRM Lead Information | Communication";
  }, []);

  return (
    <main id="app">
      <Header moduleName="crm" />
      <CrmLeadCommunicationRecievedBody />
    </main>
  );
};

export default CrmLeadCommunicationRecieved;
